import { Component, OnInit, Inject, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { NavBarService } from '../core/nav-bar/nav-bar.service';
import { fromEvent } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

const windowScrolled = fromEvent(window, 'scroll');

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, AfterViewInit {
  @ViewChild('headerSection', { static: false, read: ElementRef}) headerSectionRef: ElementRef;

  constructor(
    @Inject('WINDOW') private globalWindow: any,
    @Inject('VIEWPORT_HEIGHT') private viewportHeight: any,
    private navBarService: NavBarService
  ) {
    this.navBarService.emitChange(true);
    this.navBarService.emitThemeChange('dark');
  }

  ngOnInit() {
    this.globalWindow.scrollTo(0, 0);
  }

  ngAfterViewInit(): void {
    windowScrolled
      .pipe(distinctUntilChanged())
      .subscribe(() => {
        const scrollPosition = this.globalWindow.pageYOffset;

        const headerSectionPosition = this.headerSectionRef.nativeElement.offsetTop;
        const headerSectionHeight = this.headerSectionRef.nativeElement.offsetHeight;

        // Change nav bar color
        // if (scrollPosition >= headerSectionPosition + headerSectionHeight) {
        //   this.navBarService.emitChange(true);
        //   this.navBarService.emitThemeChange('dark');
        // } else {
        //   this.navBarService.emitChange(false);
        //   this.navBarService.emitThemeChange('light');
        // }

        if (scrollPosition >= headerSectionPosition + headerSectionHeight / 3) {
          this.navBarService.emitWithShadowChange(true);
        } else {
          this.navBarService.emitWithShadowChange(false);
        }
      });
  }
}
